import React from 'react'
import getNavigatorLanguage from 'src/utils/getNavigatorLanguage'
import { I18n } from './model'

const getCurrentLanguage = () => {
  // 先找localstorage的語系
  let currentLanguage = window.localStorage.getItem('language') ? window.localStorage.getItem('language') : getNavigatorLanguage()
  // 沒找到繁中或英語的時候再找navigator的語系
  if (currentLanguage?.includes('en') || !currentLanguage?.includes('zh')) {
    currentLanguage = 'en'
  }
  if (currentLanguage?.includes('zh')) {
    currentLanguage = 'zh-TW'
  }
  return currentLanguage
}

const LanguageProvider: React.FC = ({ children }) => {
  const [language, setLanguage] = React.useState(getCurrentLanguage)

  return <I18n.Provider value={{ language, setLanguage }}>{children}</I18n.Provider>
}

export default LanguageProvider
